var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgOfficedeskinline = function SvgOfficedeskinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "officedesk_inline_svg__Layer_1",
    x: 0,
    y: 0,
    style: {
      enableBackground: "new 0 0 50 50"
    },
    viewBox: "3 0 50 50"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".officedesk_inline_svg__st1{fill:#00a98f}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "officedesk_inline_svg__XMLID_11628_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "officedesk_inline_svg__XMLID_11190_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "officedesk_inline_svg__XMLID_11217_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "officedesk_inline_svg__XMLID_11218_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "officedesk_inline_svg__XMLID_11219_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "officedesk_inline_svg__XMLID_11220_",
    d: "M35.5 34.1v-1.2H34v-.8h5.6V21.7H24.8v10.4h5.5v.8h-1.5v1.2H10.7V36h28.9v-1.9h-4.1zm-4-2h1.4v.8h-1.4v-.8z",
    className: "officedesk_inline_svg__st1"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "officedesk_inline_svg__XMLID_11222_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "officedesk_inline_svg__XMLID_11223_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "officedesk_inline_svg__XMLID_11224_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "officedesk_inline_svg__XMLID_11225_",
    d: "M22 12H11.3c-.5 0-1 .4-1 1v14.5c0 .5.4 1 1 1H22c.5 0 1-.4 1-1V13c0-.6-.5-1-1-1zm-1 14.5h-8.8V13.9H21v12.6z",
    className: "officedesk_inline_svg__st1"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "officedesk_inline_svg__XMLID_11229_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "officedesk_inline_svg__XMLID_11230_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "officedesk_inline_svg__XMLID_11231_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "officedesk_inline_svg__XMLID_11232_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "officedesk_inline_svg__XMLID_11233_",
    d: "M29.1 13.8c-.2.4-.6.6-1 .7h-3.9c-.2 0-.3-.1-.3-.3 0-.2.1-.3.3-.3H28c.2 0 .4-.2.6-.4.2-.3.1-.7-.2-.8-.1 0-.2-.1-.2-.1-.1 0-.3.1-.4.2v.2c0 .2-.1.3-.3.4-.2 0-.3-.1-.4-.3 0-.2 0-.5.1-.7.2-.3.5-.5.9-.5.2 0 .4.1.6.2.7.4.8 1.1.4 1.7z",
    className: "officedesk_inline_svg__st1"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "officedesk_inline_svg__XMLID_11234_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "officedesk_inline_svg__XMLID_11235_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "officedesk_inline_svg__XMLID_11236_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "officedesk_inline_svg__XMLID_11237_",
    d: "M30.7 19.5c-.2.1-.4.2-.6.2-.4 0-.7-.2-.9-.5-.1-.2-.2-.4-.1-.7 0-.2.2-.3.4-.3s.3.2.3.4v.2c.1.2.2.2.4.2.1 0 .2 0 .2-.1.3-.2.4-.6.2-.8-.1-.2-.3-.3-.6-.4h-4.5c-.2 0-.3-.2-.3-.3 0-.2.1-.3.3-.3H30c.4.1.8.3 1 .7.5.5.3 1.3-.3 1.7z",
    className: "officedesk_inline_svg__st1"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "officedesk_inline_svg__XMLID_11238_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "officedesk_inline_svg__XMLID_11239_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "officedesk_inline_svg__XMLID_11240_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "officedesk_inline_svg__XMLID_11241_",
    d: "M33.4 15.8c-.2.4-.6.6-1 .7h-4.2c-.2 0-.3-.2-.3-.3 0-.2.1-.3.3-.3h4.2c.2 0 .4-.2.6-.4.2-.3.1-.7-.2-.9-.1 0-.2-.1-.2-.1-.1 0-.3.1-.4.2 0 .1-.1.1 0 .2 0 .2-.1.3-.3.4-.2 0-.3-.1-.4-.3 0-.2 0-.5.1-.7.2-.3.5-.5.9-.5.2 0 .4.1.6.2.5.4.7 1.2.3 1.8z",
    className: "officedesk_inline_svg__st1"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "officedesk_inline_svg__XMLID_11242_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "officedesk_inline_svg__XMLID_11243_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "officedesk_inline_svg__XMLID_11244_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "officedesk_inline_svg__XMLID_11245_",
    d: "M27.1 16.1c0 .2-.1.3-.3.3h-.6c-.2 0-.3-.2-.3-.3 0-.2.1-.3.3-.3h.6c.1 0 .3.1.3.3z",
    className: "officedesk_inline_svg__st1"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "officedesk_inline_svg__XMLID_11246_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "officedesk_inline_svg__XMLID_11247_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "officedesk_inline_svg__XMLID_11248_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "officedesk_inline_svg__XMLID_11249_",
    d: "M25.1 16.1c0 .2-.1.3-.3.3h-.7c-.2 0-.3-.2-.3-.3 0-.2.1-.3.3-.3h.7c.2 0 .3.1.3.3z",
    className: "officedesk_inline_svg__st1"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "officedesk_inline_svg__XMLID_11250_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "officedesk_inline_svg__XMLID_11251_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "officedesk_inline_svg__XMLID_11252_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "officedesk_inline_svg__XMLID_11253_",
    d: "M18.9 17.8c0 .9-.7 1.7-1.7 1.7-.9 0-1.7-.7-1.7-1.7 0-.9.7-1.7 1.7-1.7 1 .1 1.7.8 1.7 1.7z",
    className: "officedesk_inline_svg__st1"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "officedesk_inline_svg__XMLID_11254_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "officedesk_inline_svg__XMLID_11256_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "officedesk_inline_svg__XMLID_11257_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "officedesk_inline_svg__XMLID_11258_",
    d: "M16.9 15.2h.7v.7h-.7z",
    className: "officedesk_inline_svg__st1"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "officedesk_inline_svg__XMLID_11259_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "officedesk_inline_svg__XMLID_11260_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "officedesk_inline_svg__XMLID_11261_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "officedesk_inline_svg__XMLID_11262_",
    d: "M14.6 17.5h.7v.7h-.7z",
    className: "officedesk_inline_svg__st1"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "officedesk_inline_svg__XMLID_11263_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "officedesk_inline_svg__XMLID_11264_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "officedesk_inline_svg__XMLID_11265_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "officedesk_inline_svg__XMLID_11266_",
    d: "M15.2 15.8h.7v.7h-.7z",
    className: "officedesk_inline_svg__st1"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "officedesk_inline_svg__XMLID_11267_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "officedesk_inline_svg__XMLID_11268_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "officedesk_inline_svg__XMLID_11269_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "officedesk_inline_svg__XMLID_11270_",
    d: "M15.2 19.2h.7v.7h-.7z",
    className: "officedesk_inline_svg__st1"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "officedesk_inline_svg__XMLID_11271_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "officedesk_inline_svg__XMLID_11272_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "officedesk_inline_svg__XMLID_11273_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "officedesk_inline_svg__XMLID_11274_",
    d: "M18.6 15.8h.7v.7h-.7z",
    className: "officedesk_inline_svg__st1"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "officedesk_inline_svg__XMLID_11275_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "officedesk_inline_svg__XMLID_11276_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "officedesk_inline_svg__XMLID_11277_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "officedesk_inline_svg__XMLID_11278_",
    d: "M18.6 19.2h.7v.7h-.7z",
    className: "officedesk_inline_svg__st1"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "officedesk_inline_svg__XMLID_11279_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "officedesk_inline_svg__XMLID_11280_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "officedesk_inline_svg__XMLID_11281_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "officedesk_inline_svg__XMLID_11282_",
    d: "M19.2 17.5h.7v.7h-.7z",
    className: "officedesk_inline_svg__st1"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "officedesk_inline_svg__XMLID_11283_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "officedesk_inline_svg__XMLID_11284_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "officedesk_inline_svg__XMLID_11285_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "officedesk_inline_svg__XMLID_11286_",
    d: "M16.9 19.8h.7v.7h-.7z",
    className: "officedesk_inline_svg__st1"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "officedesk_inline_svg__XMLID_11287_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "officedesk_inline_svg__XMLID_11288_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "officedesk_inline_svg__XMLID_11289_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "officedesk_inline_svg__XMLID_11290_",
    d: "M17 21.8c-.2-.3-.6-.5-.9-.6-.5-.1-1-.1-1.4.2-.5.3-.8.7-.9 1.3-.6.4-.8 1.1-.6 1.8.2.6.8 1 1.4 1h2.3c1 0 1.8-.8 1.8-1.8 0-1.1-.8-1.9-1.7-1.9zm-.1 2.6h-2.3c-.2 0-.4-.1-.5-.3-.1-.3 0-.6.3-.7l.3-.2v-.3c0-.3.2-.6.4-.7.1-.1.3-.1.4-.1h.2c.2.1.4.2.5.4l.2.3h.3c.5-.1 1 .3 1 .8.1.4-.3.8-.8.8z",
    className: "officedesk_inline_svg__st1"
  }))))))));
};
export default SvgOfficedeskinline;